import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { NgxSpinnerService } from 'ngx-spinner';
import { Observable } from 'rxjs';
import { SurtimientoService } from 'src/app/services/Almacen/surtimiento.service';
import { Almacen } from '../../ABC/utils/models/ABC';
import { ABCService } from '../../ABC/utils/services/ABC.service';
import { SurtimientoDetalleComponent } from './surtimiento-detalle/surtimiento-detalle.component';

@Component({
  selector: 'app-firma-surtimiento',
  templateUrl: './firma-surtimiento.component.html',
  styleUrls: ['./firma-surtimiento.component.scss']
})
export class FirmaSurtimientoComponent implements OnInit {

  surtimientos: any[] = [];
  almacenes: Almacen[] = [];

  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  public surtimientos$: Observable<any[]>;
  public dataSource: MatTableDataSource<any>;
  // public selection: SelectionModel<any>;
  public displayedColumns: string[] = [];
  public listSurtimientos: any = [];

  filtros: FormGroup = new FormGroup({
    fechaInicio: new FormControl(new Date(), {}),
    fechaFin: new FormControl(new Date()),
    almacen: new FormControl('1'),
  });

  constructor(
    private surtimientoService: SurtimientoService,
    private abcService: ABCService,
    private matDialog: MatDialog,
    private spinner: NgxSpinnerService,
  ) { }

  ngOnInit(): void {
    this.abcService.getAlmacenes('Todos', true).subscribe((almacenes) => {
      this.almacenes = almacenes.almacenes;
    });
    this.obtenerDatos();
  }

  public today = (): Date => {
    return new Date();
  };

  obtenerDatos(): void {
    this.spinner.show('spinner-surtimientos');
    let filtros = this.filtros.value;

    this.surtimientoService.getSurtimientos(5, filtros.fechaInicio, filtros.fechaFin, filtros.almacen).subscribe((surtimientos: any) => {
      this.dataSource = new MatTableDataSource(surtimientos.data);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.displayedColumns = ['Surtimiento', 'Fecha', 'Orden', 'Pedido', 'Cliente'];
      this.spinner.hide('spinner-surtimientos');
    });
  }

  public mostrarModal = (surtimiento: any) => {
    const dialogRef = this.matDialog.open(SurtimientoDetalleComponent, {
      disableClose: true,
      width: '90%',
      maxWidth: '700px',
      data: {
        surtimiento
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result === true) {
        this.listSurtimientos = [];
        //this.selection.clear();
        this.obtenerDatos();
      }
    });
  }

  filter(event: Event) {
    const filter = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filter.trim().toLowerCase();
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }


  /* obtenerDatos(testBlob: Blob | null = null): void {
    let filtros = this.filtros.value;

    const formData = new FormData();
    formData.append('empresaId', '5');
    formData.append('fechaInicio', filtros.fechaInicio);
    formData.append('fechaFin', filtros.fechaFin);
    formData.append('almacen', "1");
    formData.append('testBlob', testBlob || new Blob(), 'firma.png');
    this.surtimientoService.getSurtimientos(formData).subscribe((surtimientos: any) => {
      this.surtimientos = surtimientos.surtimientos;
    });
  } */
}
